import { render, staticRenderFns } from "./getBgqycscqycxqkb.vue?vue&type=template&id=1a15047c&scoped=true&"
import script from "./getBgqycscqycxqkb.vue?vue&type=script&lang=js&"
export * from "./getBgqycscqycxqkb.vue?vue&type=script&lang=js&"
import style0 from "./getBgqycscqycxqkb.vue?vue&type=style&index=0&id=1a15047c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15047c",
  null
  
)

export default component.exports